export enum FilterType {
  Division = "Division",
  Group = "Group",
  JobLevel = "Job level",
  OfficeLocation = "Office location",
}

export type Filter = { name: string; value: string; type: FilterType };
